import { RootState } from '../../../app';
import { createSelector } from '@reduxjs/toolkit';
import { selectWithError } from '../../../../src/shared/lib';

export const selectSidebarOption = ({ editorLeftSidebar }: RootState) =>
  editorLeftSidebar.selectedOption;

export const selectActiveConversionPanel = ({ editorLeftSidebar }: RootState) =>
  editorLeftSidebar.activeConversionPanel;
export const selectCurrentPageOrTemplate = createSelector(
  [
    ({ pages }: RootState) => pages.currentPage,
    ({ templates }: RootState) => templates.currentTemplate,
  ],
  (page, template) => page || template
);

export const selectCurrentPageOrTemplateWithError = selectWithError(
  selectCurrentPageOrTemplate,
  'currentPageOrTemplate'
);

export const selectContactCardEditorOpen = ({ editorLeftSidebar }: RootState) =>
  editorLeftSidebar.contactCardEditorOpen;

export const selectContactCardEditedData = ({ editorLeftSidebar }: RootState) =>
  editorLeftSidebar.contactCardEditedData;

export const selectContactCardEditedPos = ({ editorLeftSidebar }: RootState) =>
  editorLeftSidebar.contactCardEditedPos;

export const selectSnippetForPreview = ({ editorLeftSidebar }: RootState) =>
  editorLeftSidebar.snippetForPreview;

export const selectIsTemplateApplying = ({ editorLeftSidebar }: RootState) =>
  editorLeftSidebar.isTemplateApplying;
